<template>
    <div class="messageContainer" @mouseover="isHovering = true" @mouseout="isHovering = false">
        <button :class="['btn', 'replyButton', { merchantMessage: message.sent_by_merchant }]" @click="setReplyToMessage">
            <img class="replyImage" :src="loadFile(images.reply)" width="14" height="14">
        </button>
        <slot></slot>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { loadFile } from '@/components/utils.js'
import { useStore } from 'vuex';

const props = defineProps({
    message: Object,
});

const store = useStore();

const images = {
    reply: 'replyArrow.svg',
}

const isHovering = ref(false);

const setReplyToMessage = () => {
    store.commit('Chat/setReplyToMessage', props.message);
}

</script>

<style scoped lang="scss">
@import './styles/messageWrapper.scss';
</style>
